function msToJsDate(msDate){var jO=new Date(((msDate-25569)*86400000));var tz=jO.getTimezoneOffset();var jO=new Date(((msDate-25569+(tz/(60*24)))*86400000));return jO;}
function jsToMsDate(jsdate) {
	var timezoneOffset=jsdate.getTimezoneOffset()/(60*24);
	var msDateObj=(jsdate.getTime()/86400000)+(25569 - timezoneOffset);
	return msDateObj;
}